import { DEFAULT_COLUMN_STYLE } from '~/components/MultiGrid/constants';
import { IBaseFieldData, IColumnStyle } from '~/components/MultiGrid/types';

export const INVOICE_FIELDS_ORDER = [
  'invoice_number',
  'created_on',
  'amount',
  'due_date',
  'status',
  'download',
  'actions',
];

export const INVOICE_ALL_FIELDS: Record<IBaseFieldData['value'], IBaseFieldData & IColumnStyle> =
  Object.freeze({
    invoice_number: {
      label: 'Invoice',
      value: 'invoice_number',
      ...DEFAULT_COLUMN_STYLE,
      width: 230,
      isStatic: true,
      isSortable: true,
    },
    created_on: {
      label: 'Date Created',
      value: 'created_on',
      ...DEFAULT_COLUMN_STYLE,
      width: 190,
      isSortable: true,
    },
    amount: {
      label: 'Amount',
      value: 'amount',
      ...DEFAULT_COLUMN_STYLE,
      isCellFullWidth: true,
      width: 200,
    },
    due_date: {
      label: 'Due Date',
      value: 'due_date',
      ...DEFAULT_COLUMN_STYLE,
      isCellFullWidth: true,
      width: 200,
      isSortable: true,
    },
    status: {
      label: 'Status',
      value: 'status',
      ...DEFAULT_COLUMN_STYLE,
      isCellFullWidth: true,
      width: 180,
    },
    download: {
      label: '',
      value: 'download',
      ...DEFAULT_COLUMN_STYLE,
      width: 60,
      isCellFullWidth: true,
    },
    actions: {
      label: '',
      value: 'actions',
      ...DEFAULT_COLUMN_STYLE,
      width: 60,
      isCellFullWidth: true,
    },
  });

export const INVOICE_FILTER_OPTIONS: Record<
  string,
  Array<{
    id: string;
    name: string;
    dataProps: { 'data-name': string };
  }>
> = Object.freeze({});
